import { css } from "@emotion/react";

import * as ui from "../../ui";

export const filterContainer = css`
  ${ui.column("xs")};
  align-items: center;

  @media (min-width: ${ui.breakpoints.sm}px) {
    ${ui.row("sm")}
  }
`;

export const filterInputContainer = (isLastOne: boolean) => css`
  ${ui.row("xs")};
`;

export const filterLabel = css`
  font-style: normal;
  font-weight: 400;
  font-size: ${ui.rem(14)};
  line-height: ${ui.rem(30)};
  color: #000000;
`;

export const filterInput = css`
  font-style: normal;
  font-weight: 400;
  font-size: ${ui.rem(14)};
  line-height: ${ui.rem(14)};
  color: #000000;
  border-radius: ${ui.rem("xs")};
  padding: ${ui.rem("xs")} ${ui.rem("sm")};
  border: 1px solid #b3b3b3;

  :focus,
  :focus-within,
  :focus-visible,
  :visited {
    outline: none;
  }

  @media (max-width: ${ui.breakpoints.sm - 1}px) {
    width: 100%;
  }
`;

export const filterTitle = css`
  font-style: normal;
  font-weight: 700;
  font-size: ${ui.rem(20)};
  line-height: ${ui.rem(30)};
  color: #545454;
`;

export const optionsButtons = css`
  cursor: pointer;
  background-color: #ffffff;
  padding: ${ui.rem("xs")} ${ui.rem("sm")};
  border-radius: ${ui.rem("xs")};
  font-style: normal;
  font-weight: 400;
  font-size: ${ui.rem(14)};
  line-height: ${ui.rem(14)};
  color: #000000;

  background-color: #444444;
  color: #ffffff;
`;
